/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import lazyLoading from './lazyLoading'
import superClip from '../components/feature-controller/superClip'
import callForward from '../components/feature-controller/callForward'
import NotFound from '../views/NotFound'

export default [
  {
    path: '/',
    redirect: '/personal'
  },
  {
    path: '/personal',
    name: 'Personal',
    component: lazyLoading('Personal'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: lazyLoading('Home')
      },
      {
        path: '/bundles',
        name: 'Bundles',
        component: lazyLoading('Bundles')
      },
      {
        path: '/bundles/:id',
        name: 'BundleViaCategory',
        component: lazyLoading('Bundles')
      },
      {
        path: '/bundle-details/:type/:id',
        name: 'BundleDetails',
        component: lazyLoading('BundleDetails')
      },
      {
        path: '/products',
        component: lazyLoading('Products')
        // redirect: '/products/mtn-lines'
      },
      {
        path: '/products/:id',
        name: 'Products',
        component: lazyLoading('Products')
      },
      {
        path: '/products/:id/:type',
        component: lazyLoading('Products')
      },
      {
        path: '/offers',
        name: 'Offers',
        component: lazyLoading('Offers')
      },
      {
        path: '/roaming',
        name: 'Roaming',
        component: lazyLoading('Roaming')
      },
      {
        path: '/SMS-Roaming-Countries',
        name: 'SMSRoamingCountries',
        component: lazyLoading('SMSRoamingCountries')
      },
      {
        path: '/app-details/:id',
        name: 'AppDetails',
        component: lazyLoading('AppDetails')
      },
      {
        path: '/service-details/:id',
        name: 'ServiceDetails',
        component: lazyLoading('ServiceDetails')
      },
      {
        path: '/offer-details/:type/:id',
        name: 'OfferDetails',
        component: lazyLoading('OfferDetails')
      },
      {
        path: '/reserve-number',
        name: 'ReserveNumber',
        component: lazyLoading('ReserveNumber')
      },
      {
        path: '/Reservation',
        name: 'Reservation',
        component: lazyLoading('Reservation')
      },
      {
        path: '/international-Roaming-Countries',
        name: 'InternationalRoamingCountries',
        component: lazyLoading('InternationalRoamingCountries')
      },
      {
        path: '/about-mtn',
        redirect: '/about-mtn/who-we-are'
      },
      {
        path: '/about-mtn/:id',
        name: 'AboutMtn',
        component: lazyLoading('AboutMtn')
      },
      {
        path: '/support',
        redirect: '/support/FAQs'
      },
      {
        path: '/support/:id',
        name: 'support',
        component: lazyLoading('Support')
      },
      {
        path: '/news-details/:type/:id',
        name: 'news',
        component: lazyLoading('PressReleasesCards')
      },
      {
        path: '/segment-details/:id',
        name: 'news',
        component: lazyLoading('SegmentDetails')
      },
      {
        path: '/super-clip',
        name: 'SuperClip',
        component: superClip
      },
      {
        path: '/call-forward',
        name: 'CallForward',
        component: callForward
      }
    ]
  },
  // {
  //   path: '/business',
  //   name: 'Business',
  //   component: lazyLoading('Business')
  // },
  // {
  //   path: '/payment',
  //   name: 'Payment',
  //   component: lazyLoading('Payment')
  // },
  // {
  //   path: '/mtn-World',
  //   name: 'MtnWorld',
  //   component: lazyLoading('MtnWorld')
  // },
  {
    path: '/profile',
    name: 'Profile',
    component: lazyLoading('Profile')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]
